import {useState,useEffect} from 'react'
import systemMasterServices from '../app/master/systemMasterServices';


function useSystemMasterList(masterNameList,type) {

    /* Start Masters Setting  */
    const [masters,setMasters] = useState(null);
    const getMasterList = () => {
        if(type === undefined) {
            systemMasterServices.get(masterNameList).then(res=>{
                setMasters(res);
            }).catch(error=>{

            })
        } else {
            systemMasterServices.getWithAllOptions(masterNameList).then(res=>{
                setMasters(res);
            }).catch(error=>{
                
            })
        }
    }
    const getMasterLabel = (type, id) => {
        try{
            let label = masters[type].find(m => m.value === id)
            return label.label;
        } catch(e){
            //console.log(type,id);
            return "";
        }
    }
    useEffect(()=>{
        getMasterList();
    },[])
    /* End Masters Setting  */

    return [masters,getMasterLabel];
}

export default useSystemMasterList
